import {MorphoNode, Path} from './typings';
import {getMorphoService, serviceNames} from '@/rte/editor';
import {getEditor, findNodeById} from './utils';
import {getCurrentCard} from './getCurrentCard';

const generateNodeByType = (type: string, content: any, attributes?: any): any => {
    // 字符串数组
    const contentTextArray = Array.isArray(content) && typeof content[0] === 'string' ? content : null;
    // 字符串二维数组
    const contentTextsArray: string[][] | null = Array.isArray(content) && Array.isArray(content[0]) ? content : null;
    // 结点数组
    const contentNodes = !contentTextsArray && typeof content === 'object' ? content : null;
    // 单纯字符串
    const singleContentText: string
        = !contentTextArray && !contentTextsArray && !contentNodes && content.toString() || null;
    switch (type) {
        case 'paragraph': {
            const node = {
                type: 'paragraph',
                children: contentNodes || [{text: singleContentText}],
                ...attributes,
            };
            return node;
        }
        case 'heading': {
            const node = {
                type: 'heading',
                level: 1,
                children: contentNodes || [{text: singleContentText}],
                ...attributes,
            };
            return node;
        }
        // case 'card': {
        //     const cardService = getMorphoService(serviceNames.ICardService);
        //     const cardNode = cardService.
        // }
        case 'table': {
            let tableRows = [];
            if (contentNodes) {
                tableRows = contentNodes;
            }
            else if (contentTextsArray) {
                tableRows = contentTextsArray.map((row) => {
                    return generateNodeByType('table-row', row.map((cell) => generateNodeByType('table-cell', cell)));
                });
            }
            else {
                tableRows = [
                    generateNodeByType('table-row', [generateNodeByType('table-cell', singleContentText)]),
                ];
            }

            const node = {
                type: 'table',
                children: tableRows,
                data: {
                    width: new Array(tableRows[0].children.length).fill(100),
                },
                ...attributes,
            };
            return node;
        }
        case 'table-row': {
            let rowChildren = [];
            if (contentNodes) {
                rowChildren = contentNodes;
            }
            else if (contentTextArray) {
                rowChildren = contentTextArray.map((cell) => generateNodeByType('table-cell', cell));
            }
            else {
                rowChildren = [generateNodeByType('table-cell', singleContentText)];
            }
            const node = {
                type: 'table-row',
                children: rowChildren,
                ...attributes,
            };
            return node;
        }
        case 'table-cell': {
            const node = {
                type: 'table-cell',
                children: contentNodes || [generateNodeByType('paragraph', singleContentText)],
                data: {
                    colspan: 1,
                    rowspan: 1,
                },
                ...attributes,
            };
            return node;
        }
        case 'ordered-list':
            break;
        case 'unordered-list':
            break;
        case 'todo-list':
            break;
    }
    return {
        type,
        attributes,
        children: [],
    };
};

/* eslint-disable max-statements */
const getInsertPath = (editor: any, at: string, builderId: string, type: string) => {
    let insertPath: Path = [];
    const hasCardNode = editor.children.some((node: any) => node.type === 'card');
    switch (at) {
        case 'start':
            // 文档起始位置插入
            // todo 判断文档首个结点是否为块引用
            insertPath = hasCardNode ? [1, 0, 0] : [1];
            if (type === 'card') {
                insertPath = [1];
            }
            break;
        case 'end': {
            // 文档末尾插入
            const lastNode = editor.children[editor.children.length - 1];
            if (lastNode.type === 'card') {
                insertPath = [editor.children.length - 1, 0, lastNode.children[0].children.length];
            }
            else if (lastNode.type === 'transclusion-reference' && hasCardNode) {
                // todo 在后面插入一个卡片
            }
            else {
                insertPath = [editor.children.length];
            }
            if (type === 'card') {
                insertPath = [editor.children.length];
            }
            break;
        }
        case 'cardStart': {
            const currentCard = getCurrentCard(builderId);
            if (currentCard) {
                insertPath = currentCard[1].concat(0, 0);
            }
            else {
                insertPath = [1];
            }
            if (type === 'card') {
                insertPath = currentCard ? currentCard[1].slice(0, 1) : [1];
            }
            break;
        }
        case 'cardEnd': {
            const currentCard = getCurrentCard(builderId);
            if (currentCard) {
                insertPath = currentCard[1].concat(0, currentCard[0].children.length);
            }
            if (type === 'card') {
                insertPath = [editor.children.length];
            }
            break;
        }
        case 'before': {
            const flexBuilderNode = findNodeById(builderId, editor.children, [], 'builderId');
            if (flexBuilderNode && flexBuilderNode[1]) {
                insertPath = flexBuilderNode[1].slice(0);
            }
            if (type === 'card') {
                const currentCard = getCurrentCard(builderId);
                if (currentCard) {
                    insertPath = currentCard[1].slice(0, 1);
                }
                else if (flexBuilderNode) {
                    insertPath = flexBuilderNode[1].slice(0, 1);
                }
            }
            break;
        }
        case 'after': {
            const flexBuilderNode = findNodeById(builderId, editor.children, [], 'builderId');
            if (flexBuilderNode && flexBuilderNode[1]) {
                insertPath = flexBuilderNode[1].slice(0);
                insertPath[insertPath.length - 1]++;
            }
            if (type === 'card') {
                const currentCard = getCurrentCard(builderId);
                if (currentCard) {
                    insertPath = currentCard[1].slice(0, 1);
                    insertPath[insertPath.length - 1]++;
                }
                else if (flexBuilderNode) {
                    insertPath = flexBuilderNode[1].slice(0, 1);
                    insertPath[insertPath.length - 1]++;
                }
            }
            break;
        }
    }
    return insertPath;
};

const getNodeChildrenFromContent = (content: string | string[] | MorphoNode[] | undefined) => {
    if (!content) {
        return;
    }
    if (typeof content === 'string') {
        return [generateNodeByType('paragraph', content)];
    }
    if (Array.isArray(content) && typeof content[0] === 'string') {
        // 字符串数组
        return content.map(eachContent => generateNodeByType('paragraph', eachContent));
    }
    // 认为是结点数组
    return content;
};

const getInsertMethod = (builderId: string) => {

    return (
        // 插入类型
        type: string,
        at: Path | 'start' | 'end' | 'before' | 'after' | string,
        options?: {
            // 添加到结点上的属性
            attributes?: any;
            // 结点的内容，可以为字符串，也可以为结点数组
            content?: string | string[] | MorphoNode[];
        }
    ) => {
        const editor = getEditor();
        if (!editor) {
            return;
        }
        const transformService = getMorphoService(serviceNames.ITransformService);
        let insertPath: Path = [];

        if (Array.isArray(at)) {
            insertPath = at;
        }
        else if (typeof at === 'string' && !['start', 'end', 'before', 'after', 'cardStart', 'cardEnd'].includes(at)) {
            const atNode = findNodeById(at, editor.children, []);
            if (atNode?.[1]) {
                insertPath = atNode[1].slice(0);
                insertPath[insertPath.length - 1]++;
            }
        }
        else {
            insertPath = getInsertPath(editor, at, builderId, type);
        }
        if (!insertPath || insertPath.length === 0) {
            return;
        }
        if (Array.isArray(options?.content) && !Array.isArray(options.content[0])
            && typeof options.content[0] !== 'string') {
            // 此场景认为是结点数组
            transformService.insertNodes(options.content, {at: insertPath});
            return;
        }
        if (type === 'card') {
            const cardService = getMorphoService(serviceNames.ICardService);
            if (cardService) {
                const children = getNodeChildrenFromContent(options?.content);
                cardService.insertCard({
                    path: insertPath,
                    children,
                    ...options?.attributes,
                });
            }
            return;
        }
        if (type === 'layout') {
            const layoutService = getMorphoService(serviceNames.ILayoutService);
            if (layoutService) {
                let children = getNodeChildrenFromContent(options?.content);
                if (children) {
                    children = children.map(nodes => [nodes]);
                }
                layoutService.insertLayout(
                    editor,
                    options?.attributes?.layoutView || 'column',
                    options?.attributes?.cellCount || children?.length || 3,
                    {
                        at: insertPath,
                        children,
                        ...options?.attributes,
                    }
                );
            }
            return;
        }
        const node = generateNodeByType(type, options?.content || '', options?.attributes || null);
        node && node.children.length > 0 && transformService.insertNodes(node, {at: insertPath});
    };
};

const testInsert = getInsertMethod('test-builder');
(window as any).testInsert = testInsert;

const insertRow = (tableId: string, rowContent: string[]|any[], index?: number) => {
    const editor = getEditor();
    if (!editor) {
        return;
    }
    const tableNode = findNodeById(tableId, editor.children, []);
    if (!tableNode) {
        return;
    }
    let rowChildren = [];
    if (typeof rowContent[0] === 'string' || typeof rowContent[0] === 'number') {
        rowChildren = rowContent.map(cellText => generateNodeByType('table-cell', cellText));
    }
    else {
        rowChildren = rowContent;
    }
    const rowNode = generateNodeByType('table-row', rowChildren);
    const transformService = getMorphoService(serviceNames.ITransformService);
    index = typeof index === 'number' ? index : tableNode[0].children.length as number;
    transformService.insertNodes(rowNode, {at: tableNode[1].concat(index)});
};

export {getInsertMethod, insertRow};
